import React, { useState, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
// import LoadingButton from "@mui/lab/LoadingButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { css, jsx } from '@emotion/react'
// import { withRouter, useParams } from "react-router-dom";
 
import { messageTheme, MessageContent } from "./css";
import { TypeIcon } from "../Modal/css";

export const Types = ["info", "success", "error", "warn", "loading"];

const BaseMessage = (props) => {
  const {
    id,
    type,
    msg,
    close,
    delayTime = 5000,
    moveWrapper,
  } = props;

  const [isOpen, setOpen] = useState(true);

  if (type && !Types.includes(type)) {
    console.error("type '${type} is invalid");
  }

  let Icon = null
  if (Types.includes(type)) {
    Icon = type === 'loading' ? <CircularProgress size={20} /> : <TypeIcon className={`small ${type}`}></TypeIcon>
  }
  const message = type === 'loading' ? (msg || 'loading...') : msg
  const content = <MessageContent>
    {Icon}
    <span>{message}</span>
  </MessageContent>

  const [className, setClassName] = useState("start")
  useEffect(() => {
    setClassName('')
  }, [])

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (type !== 'loading') {
          moveWrapper()
          setClassName('scale0')
          setTimeout(() => {
            setOpen(false)
            close()
          }, 300);
        }
      }, delayTime);
    }
  }, [isOpen])

  useEffect(() => {
    const dom = document.querySelector(`#${id}`)
    if (dom) {
      const div = dom.querySelector('div')
      if (div) {
        setTimeout(() => {
          dom.style.height = `${div.clientHeight}px`;
        }, 150);
      }
    }
  }, [])

  return (
    <ThemeProvider theme={messageTheme}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isOpen}
        message={content}
        className={className}
        // onClose={handleClose}
        // TransitionComponent={state.Transition}
        // key={state.Transition.name}
      />
    </ThemeProvider>
  );
};

export default BaseMessage;
